(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/views/ongoing-swipe.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/views/ongoing-swipe.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.result_boxes=_svs.sport.result_boxes||{};
_svs.sport.result_boxes.templates=_svs.sport.result_boxes.templates||{};
svs.sport.result_boxes.templates.ongoing_swipe = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "swipe-boxes-multiple";
},"3":function(container,depth0,helpers,partials,data) {
    return "swipe-boxes-single";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"royalSlider\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.regions : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "        <div id=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"></div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.regions : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    return "      <div id=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.useSlider : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + " "
    + alias4(((helper = (helper = helpers.productClassName || (depth0 != null ? depth0.productClassName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"productClassName","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.sportName || (depth0 != null ? depth0.sportName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"sportName","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.useSlider : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(8, data, 0),"data":data})) != null ? stack1 : "")
    + "    <div class=\"swipe-arrow swipe-arrow-left hide-arrow\">\n      <i class=\"icon-default icon-badge-arrow-left swipe-icon\"></i>\n    </div>\n    <div class=\"swipe-arrow swipe-arrow-right hide-arrow\">\n      <i class=\"icon-default icon-badge-arrow-right swipe-icon\"></i>\n    </div>\n</div>\n";
},"useData":true});
Handlebars.partials['components-sport-result_boxes-ongoing_swipe'] = svs.sport.result_boxes.templates.ongoing_swipe;
})(svs, Handlebars);

 })(window);